"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Svg(_ref) {
  var styles = _ref.styles;
  return /*#__PURE__*/_react.default.createElement("svg", {
    width: "62",
    height: "62",
    viewBox: "0 0 62 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: styles
  }, /*#__PURE__*/_react.default.createElement("mask", {
    id: "mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: "0",
    y: "0",
    width: "62",
    height: "62"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    cx: "31",
    cy: "31",
    r: "31",
    fill: "#2F61E0"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#mask0)"
  }, /*#__PURE__*/_react.default.createElement("circle", {
    opacity: "0.5",
    cx: "31",
    cy: "31",
    r: "31",
    fill: "#7F5CF2"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "19",
    y: "23",
    width: "51",
    height: "50",
    rx: "6",
    fill: "#7F5CF2"
  })), /*#__PURE__*/_react.default.createElement("rect", {
    x: "8",
    y: "14",
    width: "33",
    height: "20",
    rx: "10",
    fill: "#0C1E76"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "26",
    y: "40",
    width: "14",
    height: "3",
    rx: "1.5",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("rect", {
    x: "26",
    y: "47",
    width: "24",
    height: "3",
    rx: "1.5",
    fill: "white"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M17.333 23.4167L21.4997 27.5833L30.2497 18.8333",
    stroke: "white",
    strokeWidth: "2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}

var _default = Svg;
exports.default = _default;